export interface ReportDocument {
  id: string;
  key: string;
  description: string;
  obsolete: boolean;
  defaultPrinter: string;
  noOfCopies: number;
  autoPrintDocument: boolean;
  autoPrintDocumentYesNo: string;
  attachmentPath: string;
  ccEmailAddress: string;
  bccEmailAddress: string;
  sendFromEmailAddress: string;
  internalDocument: boolean;
  internalDocumentYesNo: string;
  documentMessage: string;
  documentWidth: number;
  documentHeight: number;
  documentOrientation: string;
  topMargin: number;
  rightMargin: number;
  bottomMargin: number;
  leftMargin: number;
  documentSize: string;
  documentUnits: string;
  printBarcode: boolean;
  printQRCode: boolean;
}
